import $ from 'jquery';

export function preventDrag() {
    $('img').on('dragstart', function(event) { event.preventDefault();})
    $('a').on('dragstart', function(event) { event.preventDefault();})
}